import { Typography } from "@outschool/backpack";
import { I18nLocale, useLocale } from "@outschool/localization";
import * as React from "react";

export default function TranslationWarning() {
  const locale = useLocale();
  let translationText: string;
  switch (locale) {
    case I18nLocale.Ko:
      // es-lint-disable-next-line i18next/no-literal-string
      translationText = "보고계신 지문은 자동 번역 되었습니다";
      break;
    case I18nLocale.Ja:
      // es-lint-disable-next-line i18next/no-literal-string
      translationText = "この文章は自動翻訳されています";
      break;
    case I18nLocale.ZhTw:
      // es-lint-disable-next-line i18next/no-literal-string
      translationText = "我們無法翻譯此文，請刷新頁面並再試一次。";
      break;
    case I18nLocale.En:
    default:
      // es-lint-disable-next-line i18next/no-literal-string
      translationText = "";
  }
  return (
    <Typography
      variant="inherit"
      sx={{
        color: "grey.500",
        alignSelf: "end",
      }}
    >
      {translationText}
    </Typography>
  );
}
